import { useState } from 'react';
import { SelectChangeEvent } from '@mui/material';
import PaginationComponent from '@components/pagination/pagination.tsx';

const Block = ({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <div className="flex flex-col gap-3">
    <p className="font-semibold text-gray-700">{title}</p>
    {children}
  </div>
);

function PaginationShowcase() {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [page2, setPage2] = useState(1);
  const [rowsPerPage2, setRowsPerPage2] = useState(20);

  return (
    <div className="flex flex-col gap-10">
      <h2 className="text-xl font-bold text-gray-800">Pagination</h2>

      <Block title="Default rowsPerPageOptions">
        <PaginationComponent
          count={12}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={(_e, value) => setPage(value)}
          onRowsPerPageChange={(e: SelectChangeEvent<number>) =>
            setRowsPerPage(Number(e.target.value))
          }
        />
      </Block>

      <Block title="Custom rowsPerPageOptions">
        <PaginationComponent
          count={6}
          page={page2}
          rowsPerPage={rowsPerPage2}
          rowsPerPageOptions={[20, 40, 60]}
          onPageChange={(_e, value) => setPage2(value)}
          onRowsPerPageChange={(e: SelectChangeEvent<number>) =>
            setRowsPerPage2(Number(e.target.value))
          }
        />
      </Block>
    </div>
  );
}

export default PaginationShowcase;
